import AOS from 'aos';
import Vimeo from '@vimeo/player'; // eslint-disable-line


export default {
  init() {
    AOS.init({
      once: true,
    });

    // replace any creo.dev with cymru
    /*$('a').each(function() {
      $(this).prop('href', $(this).prop('href').replaceAll('creo.dev', 'cymru'));
    });*/
  },
  finalize() {
    if ($('.header-carousel').length !== 0) {
      $('.header-carousel').owlCarousel({
        dots: true,
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 6000,
        autoplayHoverPause: false,
      });
    }

    /**
     * add underline to footer items
     */
    $('.footer-navigation .menu-item').each(function () {
      $(this).find('.nav-link').addClass('underline-hover');
    });

    /**
     * FILTHY hack to set correct underline colour
     * surely this can be done better?
     * Optimised 09/10/2020
     */
    setTimeout(function () {
      if ($('.underline-hover').length > 0) {
        var underlineSelections = '<style type="text/css">';

        $('.underline-hover').each(function () {
          var elId;

          if ($(this).attr('id')) {
            elId = $(this).attr('id');
          } else {
            elId = '_el' + Math.floor(Math.random() * 999999)
            $(this).attr('id', elId);
          }

          const thisColor = $(this).css('color');
          underlineSelections += `#${elId}::after{border-bottom-color:${thisColor};}`;
        });

        underlineSelections += '</style>';
        $('head').append(underlineSelections);
      }
    }, 250);

    /**
     * Change 'My Account' to 'Members Log-in' if not logged in
     */
    if (!$('body').hasClass('logged-in')) {
      $('.footer-menu > li').each(function () {
        if ($(this).find('a').html().toLowerCase() === 'my account' || $(this).find('a').html().toLowerCase() === 'fy nghyfrif') {
          $(this).find('a').html($('.footer-wrap').data('members-login'));
        }
      });
    }


    /**
     * Hides either the my account button or the intranet button
     * depending on whether the user is logged in or now.
     */
    if ($('.menu-item .intranet-page').length > 0) {
      const $intranetBtn = $('.menu-item .intranet-page').parent().parent();
      const $accountBtn = $('.menu-item .my-account-page').parent().parent();

      $intranetBtn.addClass('intranet-btn');
      $intranetBtn.find('a').addClass('btn btn-primary');

      $accountBtn.addClass('intranet-btn');
      $accountBtn.find('a').addClass('btn btn-primary');

      if ($('body').data('intranet-accessible') == '1') {
        $accountBtn.remove();
      } else {
        $intranetBtn.remove();
      }
    }


    /**
     * Add language switcher manually on Cylch detail pages
     */
    if ($('body').hasClass('single-cylchs')) {
      const currentUrl = window.location.href;
      var newUrl = '';
      var newLang = 'English';
      var lang = 'en';

      // Replace either en with cy or vice versa (if possible)
      if (currentUrl.includes('?lang=')) {
        if (currentUrl.includes('?lang=en')) {
          newUrl = currentUrl.replace('en', 'cy');
          newLang = 'Cymraeg';
          lang = 'cy';
        } else {
          newUrl = currentUrl.replace('cy', 'en');
          newLang = 'English';
          lang = 'en';
        }
      } else {
        newLang = 'English';
        lang = 'en';

        if (currentUrl.includes('?')) {
          newUrl = currentUrl + '&lang=en';
        } else {
          newUrl = currentUrl + '?lang=en';
        }
      }

      const $langSwitcher = $(`<li class="menu-item"><a href="${newUrl}" class="nav-link"><span class="wpml-ls-native" lang="${lang}">${newLang}</span></a></li>`);
      $('#main-navigation .navbar-nav').append($langSwitcher);
    }

    /**
     * Select boxes with arrows
     */
    if ($('.select-accompany').length > 0) {
      $('.select-accompany').each(function () {
        const $this_ = $(this);
        const selectId = $this_.data('for-id');

        $(`#${selectId}`).on('focus', function () {
          $this_.addClass('select-focus');
        });

        $(`#${selectId}`).on('blur', function () {
          $this_.removeClass('select-focus');
        });
      });
    }

    /**
     * Navbar toggle for mobile/tablet
     */
    $('.navbar-toggler').on('click', function() {
      $('#mob-nav-wrap').toggleClass('open');
    });

    /**
     * Close dropdown container
     */
    $('.drop-down-container .close').on('click', function () {
      $('.drop-down-container').hide();
      $('body').removeClass('drop-down-open');
    });

    /**
     * Make item a 'Shop' link
     * only necessary on some translations annoyingly
     */
    if ($('.menu-item.shop-item').length > 0) {
      const $shopMenuItem = $('.menu-item.shop-item');
      $shopMenuItem.removeClass('shop-item');
      $shopMenuItem.addClass('d-flex align-items-center has-icon');
      $shopMenuItem.find('a').prepend('<span class="icon-shop"></span>');
    }

    /**
     * Add login to navigation bar
     * Add after 'Shop' link
     */
    // const myAccountUrl = $('header.banner').data('account-location');
    // const myAccountText = $('header.banner').data('account-title');
    // $(`<li class="menu-item d-flex align-items-center account-btn has-icon">
    //   <a href="${myAccountUrl}" class="nav-link btn btn-primary">${myAccountText}</a>
    // </li>`).insertAfter('#main-navigation .menu-item.has-icon');

    /**
     * Navigation tab control
     */
    $('#main-navigation .menu-item.menu-item-has-child').each(function () {
      $(this).attr('tabindex', 0);
      $(this).find('a').attr('tabindex', -1);

      $(this).on('keydown', function (e) {
        if (e.keyCode === 9) {
          $('.drop-down-container .drop-items > div:first-child > .drop-item > .item').focus();
          e.preventDefault();
        }
      });
    });

    /**
     * Navigation formatting & events.
     */
    function dropDownOpen($object) {
      $('.menu-item.menu-item-fade').each(function () {
        $(this).removeClass('menu-item-fade');
      });

      $object.siblings().each(function () {
        if (!$(this).hasClass('has-icon')) {
          $(this).addClass('menu-item-fade');
        }
      });

      $('.drop-items').empty();
      $('.highlight-item').empty();
      // Find the items.
      // var items = $object.find('a.sub-item');

      var menu_items = '';
      var image_items = '';

      $object.find('a.sub-item').each(function (index, item) {
        var $item = $(item);

        var label = '';

        if ($item.data('label')) {
          label = `<span class="label"> ${$item.data('label')} </span>`;
        }

        // WPML switcher

        if ($(this).find('.wpml-ls-native').attr('lang')) {
          var href = '?lang=' + $(this).find('.wpml-ls-native').attr('lang')
        } else {
          href = $item.attr('href')

        }

        // if ($item.data('img')) {
        //   var img = $item.data('img');
        //   image_items += `
        //   <div class="col-12">
        //       <div class="drop-item" style="background-image: url(${img.replace('/', '//')})">
        //         <div>
        //           <a class="item" href="${href}">${$item.text()}</a>
        //           ${label}
        //         </div>
        //       </div>
        //   </div>
        //   `
        // } else {

        if ($item.data('img')) {
          var img = $item.data('img');
          menu_items += `
          <div class="col-12 col-xl-2 has-image" style="background-image: url(${img.replace('/', '//')});">
              <div class="drop-item">
                  <a class="item" href="${href}">${$item.text()}</a>
                  ${label}
              </div>
          </div>`;
        } else {
          menu_items += `
          <div class="col-12 col-xl-2">
              <div class="drop-item">
                  <a class="item" href="${href}">${$item.text()}</a>
                  ${label}
              </div>
          </div>`;
        }
        // }
      })
      $('.drop-items').append(menu_items);
      $('.highlight-item').append(image_items);

      // Hook for accessibility tabbing
      if ($('.drop-down-container .highlight-item').children().length > 0) {
        $('.drop-down-container .highlight-item .item').on('keydown', function (e) {
          if (e.keyCode === 9) {
            // tabbed out of the final item
            const $nextItem = $('.drop-down-container').data('childof').next();

            if ($nextItem.hasClass('menu-item-has-child')) {
              $nextItem.focus();
            } else {
              $nextItem.find('> a').focus();
            }

            e.preventDefault();
          }
        });
      } else {
        $('.drop-down-container .drop-items > div:last-child > .drop-item > .item').on('keydown', function (e) {
          if (e.keyCode === 9) {
            // tabbed out of the final item
            const $nextItem = $('.drop-down-container').data('childof').next();

            if ($nextItem.hasClass('menu-item-has-child')) {
              $nextItem.focus();
            } else {
              $nextItem.find('> a').focus();
            }

            e.preventDefault();
          }
        });
      }

      // Show menu
      var menuColor = $object.find('a').css('color');

      if (menuColor == 'rgb(248, 197, 55)') {
        menuColor = 'rgb(255, 215, 27)';
      }

      $('.drop-down-container').css({
        'background-color': menuColor,
      });

      if (menuColor == 'rgb(255, 215, 27)') {
        $('.drop-down-container .drop-items .col-12:not(.has-image) a.item').css({
          'color': 'black',
        });

        $('.drop-down-container .drop-items .col-12:not(.has-image) span.label').css({
          'color': 'black',
        });
      }

      $('.drop-down-container').show();
      $('body').addClass('drop-down-open');
      $('.drop-down-container').data('childof', $(this));
    }

    $('.menu-item-has-child').on('mouseenter focus', function () {
      if ($(window).width() >= 1200) {
        dropDownOpen($(this));
      }
    });

    $('.menu-item-has-child').on('click', function (e) {
      if ($(window).width() < 1200) {
        e.preventDefault();
        e.stopPropagation();
        dropDownOpen($(this));
      }
    });

    $('header.banner').on('mouseleave blur', function () {
      $('.drop-down-container').hide();
      $('body').removeClass('drop-down-open');

      $('.menu-item.menu-item-fade').each(function () {
        $(this).removeClass('menu-item-fade');
      });
    });

    $('#main-navigation .menu-item:not(.menu-item-has-child), #main-navigation .menu-item:not(.menu-item-has-child) > a').on('mouseenter focus', function () {
      $('.drop-down-container').hide();
      $('body').removeClass('drop-down-open');

      $('.menu-item.menu-item-fade').each(function () {
        $(this).removeClass('menu-item-fade');
      });
    });

    // $('')

    $('.navbar-toggler').click(function () {
      $(this).toggleClass('is-active');
    });

    // Number fields
    if ($('input[type="number"]').length > 0) {
      $('input[type="number"]').each(function () {
        const $quantityField = $(this);
        $quantityField.removeClass().addClass('product-quantity-field');

        const $quantityLess = $('<span class="product-quantity-less">-</span>');
        const $quantityMore = $('<span class="product-quantity-more">+</span>');

        $quantityField.parent().append($quantityLess);
        $quantityField.parent().append($quantityMore);

        $quantityLess.on('click', function () {
          if (parseInt($quantityField.val()) > 1) {
            $quantityField.attr('value', parseInt($quantityField.val()) - 1);

            // bring back update cart if needed
            if ($('button[name="update_cart"]').length > 0) {
              $('button[name="update_cart"]').prop('disabled', false);
            }
          }
        });

        $quantityMore.on('click', function () {
          $quantityField.attr('value', parseInt($quantityField.val()) + 1);

          // bring back update cart if needed
          if ($('button[name="update_cart"]').length > 0) {
            $('button[name="update_cart"]').prop('disabled', false);
          }
        });
      });
    }

    // download button
    $('.btn-download').on('click', function () {
      $(this).addClass('btn-downloading');
    });

    // custom input fields
    $('.wpcf7-form-control:not(input[type="submit"]):not(.wpcf7-checkbox)').each(function () {
      $(this).removeClass('form-control');

      const placeholder = $(this).prop('placeholder');
      $(this).prop('placeholder', '');

      const $tooltip = $(`<span class="field-custom-label is-wpcf7-label">${placeholder}</span>`);
      $(this).parent().append($tooltip);

      $(this).on('focus', function () {
        $tooltip.addClass('label-active');
      });

      $(this).on('blur', function () {
        if ($(this).val() == '') {
          $tooltip.removeClass('label-active');
        }
      });
    });

    /**
     * Hide country/region on checkout
     */
    if ($('.form-row.form-row-wide.address-field#billing_country_field').length > 0) {
      $('.form-row.form-row-wide.address-field#billing_country_field').hide();
    }

    if ($('.form-row.form-row-wide.address-field#shipping_country_field').length > 0) {
      $('.form-row.form-row-wide.address-field#shipping_country_field').hide();
    }

    /**
     * Share this page
     */
    $('#share-open').on('click', function () {
      $(this).parent().stop().toggleClass('share-open');
      $('.a2a_floating_style').stop().toggleClass('share-open');
    });

    // Remove text on search item
    if ($('.menu-search').length > 0) {
      $('.menu-search .nav-link').html('');
      $('.menu-search .nav-link .nav-label').remove();
    }

    /**
     * Global search
     */
    const searchButton = document.querySelector('.menu-search');
    searchButton.addEventListener('click', function(e){
      e.stopPropagation();
      e.preventDefault();
      $('.search-banner').stop().slideDown();
      $('.search-banner input[name="q"]').focus();
    })

    $('#search-cancel').on('click', function() {
      $('.search-banner').stop().slideUp();
    });

    //Flexi Video block vimeo implementation
    if($('#vimeo-video').length > 0){
      const vimeoID = $('#vimeo-video').data('vimeo-id')
      var player = new Vimeo.player('vimeo-video', {id : vimeoID})
      console.log(player)
    }

    // On Learndash course completion we need to display a congratulations message
    if ($('#learndash_course_certificate').length > 0) {
      // Append an element before the 'Print your certificate' button
      const congratsMsg = $('#learndash-complete-msg').html();
      const $congratsEl = $(`<div class="py-5">${congratsMsg}</div>`);

      $congratsEl.insertBefore('#learndash_course_certificate');

      // Hide course status
      $('#learndash_course_status').hide();

      // Push content down a bit
      $('#learndash_course_content').css({ paddingTop: '6rem' });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js